module.exports = __webpack_public_path__ + "static/media/Feather-Icons.2250718e.woff";